document.addEventListener('DOMContentLoaded' , function(){
    let nextpage = 2;
    let loading = false
    const productGrid = document.querySelector('.product-grid');
    const collectionHandle = window.location.pathname.split('/').pop();
    
    window.addEventListener('scroll' , function(){
        if (window.innerHeight + window.scrollY >= this.document.body.offsetHeight - 3000 && !loading){
             
             loading = true;
            fetch(`/collections/${collectionHandle}?page=${nextpage}&view=ajax`)
            .then(response => response.text())
            .then(data => {
                const parser = new DOMParser();
                const htmlDoc = parser.parseFromString(data, 'text/html');
                const newProducts = htmlDoc.querySelectorAll('.product-grid .grid__item');
                
                if(newProducts.length > 0){
                  newProducts.forEach(product => productGrid.appendChild(product));
                  loading = false;
                  nextpage++;

                }
               
            })
            .catch(error => console.error('Error loading more products:', error))
        }
    })
})